import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {withStyles} from '@material-ui/core/styles';
import {connect} from 'react-redux';
import Loader from '../../../Helper/loader/loader';
import Avatar from '@material-ui/core/Avatar';
import './post.css';

const styles = theme => ({
  rootLeft: {
    maxWidth: '100%',
  },
  rootspace:{
    padding: '16px',
  },
  rootRight: {
    maxWidth: '100%',
  },
  gridOverflow: {
    overflow: 'auto',
    height: 'calc(122vh - 250px)',
    overflowX: 'hidden',
  },
  firstRefresh: {
    display: 'inline-block',
    position: 'relative',
    width:'80px !important',
    height:'80px !important',
    marginTop:'200px',
    color: '#a534a6'
  },
  refresh: {
    display: 'inline-block',
    position: 'relative',
    width:'40px !important',
    height:'40px !important',
    marginTop:'15px',
    color: '#a534a6'
  },
  textColor: {
    color: 'red',
  }
});

class PostAppView extends React.Component {
  constructor() {
    super();
    this.state = {
      post: [],
      isActive:false,
      total:'',
      currentCount:5,
      offset:5,
      IsFetchingPost:false,
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      post: nextProps.postData.LocalFeedList,
      total: nextProps.postData.LocalFeedList.length
    },()=>{this.loadInitialContent()})
  }

  loadInitialContent=()=>{
    let {post, offset} = this.state;
    let ary = post && post.slice(0,offset);
    this.setState({post:ary});
  };
  convertUnicode = (input) => {
    return input.replace(/\\u(\w\w\w\w)/g,(a,b) => {
      let charcode = parseInt(b,16);
      return String.fromCharCode(charcode);
    });
  };
  loadOnScroll = () =>{
    let {currentCount, isFetching, offset, total} = this.state;
    if(currentCount === total) return;
    let el = document.getElementById('post-end');
    let rect = el.getBoundingClientRect();
    let isAtEnd = (
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
    if(isAtEnd){
      if(!isFetching){
        this.setState({isFetching:true});
        setTimeout(() => {
          let count = currentCount + offset;
          if(currentCount !== total){
            this.setState({
              isFetching:false,
              currentCount:count,
              post: this.props.postData.LocalFeedList.slice(0, count)
            })
          }
        }, 2000);
      }
    }
  };

  checkFormat = (date) => {
    let arr = date.split(' ');
    return arr[0];
  };
  displayFormat=(post)=>{
    let arr;
    let arr2;
    let postArr=[];
    if(post!==null && post!=="") {
      arr = post.split("\n");
      arr.forEach((v) => {
        arr2=v.split(" ");
        arr2.forEach((a)=>{
          if (a.charAt(0) === '#')
            postArr.push("<span style='color:blue'>" + a + "</span>");
          else if(a.indexOf('#')!==-1){
            let inword=(a.split('#'))
            postArr.push(inword[0]+"<span style='color:blue'>#"+inword[1] + "</span>");
          }
          else{
            postArr.push(this.convertUnicode(a))
          }

        })
        postArr.push('<br/>');
      })
      return postArr.join(" ");
    }
    else return '';
  }
  checkProfileImg=(url)=>{
    const {user}=this.props;
    if(url=== null || url==="" ){
      return <img  src={require(`../../../images/Alphabets/${user.results.AppUser.FirstName.substring(0,1).toUpperCase()}.png`)} height={50} width={50}/>
    }else{
      return  <img src={`https://d2gnb7jphto2jj.cloudfront.net/UploadImages/AppUserProfileImages/ProfileOriginalImage/${url}`} height={50} width={50}/>
    }
  };

  render() {
    const { user, classes,postData} = this.props;

    console.log(this.props.scroll)
    return (
      <div>
        <div className={classes.gridOverflow} onScroll={this.props.scroll}>
          {
            postData.LocalFeedList.length>0 && postData.LocalFeedList.map((v, i) => {
              return v && <div className="post-css" key={i}>
                <div>
                  <div className="location-date-post">
                    <i className="fa fa-calendar" aria-hidden="true"/>&nbsp;{ v && moment(v.CreatedDate).format('MMM Do')}&nbsp;&nbsp;&nbsp;
                    <i className="fa fa-map-marker" aria-hidden="true"/>&nbsp;{Math.floor(v.Distance)>0 ?`${Math.floor(v.Distance)} miles`:'less than a mile'}
                    <img className="arrow-img" src={(require('../../../images/darrow@2x.png'))}/>
                  </div>
                  <div style={{display:"flex"}}>
                    <div className="avatar-img">
                      <Avatar className="avatar-post">
                        {this.checkProfileImg(user.results.AppUser.ProfileImage)}
                      </Avatar>
                    </div>
                    <div>

                      <div style={{float: 'left'}}>
                        <h4 className="user-name-post-appview">{user.results.AppUser.FirstName}</h4>
                        <h5 className={"user-id-post-appview"}>{`@${user.results.AppUser.UserName}`}</h5>
                      </div>
                    </div>
                  </div>
                  <div className="post-display-app-up-div-wrapper">
                    <div class="post-display-app-up-div"/>
                    <div className="post-display-app">

                      <p className="post-display-app-message" dangerouslySetInnerHTML={{__html: this.displayFormat(v.PostComment)}}/>
                      {
                        v.LocalFeedImage.length > 1000 ?
                          v.isImage === 'YES' ?
                            <img src={`data:image/jpeg;base64,${v.LocalFeedImage}`}/>
                            :
                            <video controls="controls" id="video">
                              <source src="sintel-trailer.ogv"
                                      type='video/ogg; codecs="theora, vorbis"'/>
                              <source src={`data:video/mp4;base64,${v.LocalFeedVideo}`}
                                      type='video/mp4; codecs="avc1.42E01E, mp4a.40.2"'/>
                            </video>
                          :
                          v.LocalFeedImage !== '' ?
                            <img src={v.LocalFeedImage}/>
                            :v.isVideo==='YES' &&
                            <video controls="controls" id="video">
                              <source src="sintel-trailer.ogv"
                                      type='video/ogg; codecs="theora, vorbis"'/>
                              <source src={v.LocalFeedVideo}
                                      type='video/mp4; codecs="avc1.42E01E, mp4a.40.2"'/>
                            </video>
                      }
                      <div className="comment-css">
                        <span><img src={require(`../../../images/ActivityIcons/share@3x.png`)} className="icons-css"/></span>
                        {v.ParticipantCount>0 ?
                          <span className="icon-span">
																						<img src={require(`../../../images/ActivityIcons/eventCommentgreen@3x.png`)} className="icons-css"/>
																							<span style={{color:'#0FAE22','margin-left':'-5px'}}>{v.ParticipantCount}</span>
																						</span>
                          :
                          <span className="icon-span">
                                              <img src={require(`../../../images/ActivityIcons/eventComment@3x.png`)} className="icons-css"/>
                                            </span>
                        }
                        {v.ViewCount>0
                          ? <span className="icon-span">
																							<img
                                                src={v.Like === true ? require(`../../../images/ActivityIcons/eye@3x.png`) : require(`../../../images/ActivityIcons/smile@3x.png`)}
                                                className="icons-css"/>
                            {v.LikeCount > 0 && v.LikeCount}
																						</span>
                          : <span className="icon-span">
																							<img
                                                src={v.Like === true ? require(`../../../images/ActivityIcons/smileSelected@3x.png`) : require(`../../../images/ActivityIcons/smile@3x.png`)}
                                                className="icons-css"/>
																							<span className={v.Like===true ?"like-smiley":"like-smiley-active"}> {v.LikeCount > 0 && v.LikeCount}</span>
																						</span>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            })
          }
          {
            !postData.IsFetchingPost ? <div className='text-center'><Loader/></div>
              :
              (!postData.LocalFeedList.length > 0) &&
              <div className='no-data-div-post'>@{user.results.AppUser.UserName}<br/> Doesn’t have any
                posts to show.</div>
          }
        </div>
      </div>
    )
  }
}
PostAppView.propTypes = {
  classes: PropTypes.object.isRequired,
};
const mapStateToProps=(state)=> {
  return {
    user:state.loginResponse
  }
};
export default withStyles(styles)(connect(mapStateToProps)(PostAppView));